import API, { CartItem, CartResponse } from "../api"
import GA4Utils, { GA4Item } from "../ga4"

export default class Cart {

	private static QUANTITY_NOT_INTEGER = 'Quantity must be an integer.'
	private static QUANTITY_TOO_HIGH = 'Quantity must be less than 100.'
	private static TIME_TO_SAVE_AFTER_INPUT = 2000
	private static timeout
	private static nextCartItemId = 1

	static isDevEnvironment: boolean = false
	static isBMSMPromoActive: boolean = false
	static siteName: string
	static siteDomainName: string
	static promoStart: string
	static promoEnd: string

	static promoProps: {
		promoType: "BMSM" | "GWP" | "BOGO" | "FS" | "pointsGwp"
		total?: number
		subTotal?: number
		discount?: number
		newTotal?: number
		active?: boolean
		promoTiers?: {
			minTotal: number
			dollarOff: number
		}[]
		freeGiftRemarkCopy?: string
		bogoPairs?: {
			mainSku: string
			subSku: string
			gwpSku: string
		}[]
		gwpProps?: {
			sku: string
			name: string
			qty: number
			listPrice: number
			listPoints: number
			imgPath: string
			hasGwpInCart: boolean
			bannerCopy: string
		}
	}

	static itemLoading: boolean = false
	static shippingCostLoading: boolean = false
	static handlersBound: boolean = false
	static drawerOpen: boolean = false

	static onPageLoad() {

		const isOrderPage = (window as any).location.href.toLowerCase().includes("sessionorder")

		Cart.initializeStaticProperties()
		Cart.setupGA4Items()
		Cart.bindElementHandlers()

		if (!isOrderPage) {
			Cart.checkHTML()
		}

		Cart.setupCartDrawerYMALCarousel()

		const cartItems = document.querySelectorAll('#cart-drawer-items .cart-item')
		if (cartItems.length > 0) {
			const positions = Array.from(cartItems).map(item => {
				const position = Number.parseInt((item as HTMLElement).dataset.position)
				return isNaN(position) ? 0 : position
			})
			Cart.nextCartItemId = Math.max(...positions) + 1
		} else {
			Cart.nextCartItemId = 1
		}
	}

	static initializeStaticProperties() {
		Cart.isBMSMPromoActive = (window as any).isBMSMPromoActive || false
		Cart.siteName = (window as any).siteName || ''
		Cart.siteDomainName = (window as any).siteDomainName || ''
		Cart.promoStart = (window as any).promoStart || ''
		Cart.promoEnd = (window as any).promoEnd || ''
	}

	static bindElementHandlers() {

		$('#cart-drawer .quantity-decrease, #cart-drawer .quantity-increase').on('click', (e) => {

			const cartElem = e.target.closest('li.cart-item') as HTMLUListElement

			const itemPosition = Number.parseInt(cartElem.dataset.position)
			const basketId = cartElem.dataset.basketid
			const price = Number.parseFloat(cartElem.dataset.price)
			const regularPrice = Number.parseFloat(cartElem.dataset.regularprice)
			const pricePoints = Number.parseInt(cartElem.dataset.pricepoints)

			const quantityInput = (document.getElementById(`cart-item-${itemPosition}`).querySelector('input[name="quantity"]') as HTMLInputElement)

			const oldValue = Number.parseInt(quantityInput.value)
			let operation = e.target.dataset.operation as ('increment' | 'decrement')

			let newValue = oldValue

			Cart.log(`[click] itemPosition ${itemPosition}`)

			if (operation === 'increment') {

				newValue = oldValue + 1

				if (newValue > 99) {
					alert(Cart.QUANTITY_TOO_HIGH)
					newValue = 99
				}

			} else if (operation === 'decrement') {

				newValue = oldValue - 1

				if (newValue < 0) {
					newValue = 0
				}
			}

			if (newValue !== oldValue) {

				if (newValue <= 0) {
					Cart.onClickDeleteProduct({
						basketId: basketId,
						itemPosition: itemPosition,
						oldValue: oldValue.toString(),
					})
				}

				else {
					Cart.onUpdateQuantity({
						itemPosition: itemPosition,
						oldValue: oldValue,
						newValue: newValue,
						price: price,
						regularPrice: regularPrice,
						pricePoints: pricePoints,
					})
				}
			}
		})

		$('#cart-drawer .quantity-input').on('focus', (e) => {
			const quantityInput = e.target as HTMLInputElement
			const value = Number.parseInt(quantityInput.value)
			quantityInput.dataset.oldvalue = value > 99
				? '99'
				: value < 1
					? '1'
					: value.toString()
		})

		$('#cart-drawer .quantity-input').on('focusout', (e) => {
			const quantityInput = e.target as HTMLInputElement
			const floatValue = Number.parseFloat((e.target as HTMLInputElement).value)
			const oldValue = Number.parseInt(quantityInput.dataset.oldvalue)

			if (isNaN(floatValue) || !Number.isInteger(floatValue)) {
				clearTimeout(Cart.timeout)
				alert(Cart.QUANTITY_NOT_INTEGER)
				quantityInput.value = oldValue.toString()
			}
		})

		$('#cart-drawer .quantity-input').on('input', (e) => {

			const unorderedListElem = e.target.closest('li.cart-item') as HTMLUListElement
			const itemPosition = Number.parseInt(unorderedListElem.dataset.position)

			document.querySelectorAll('.quantity-input').forEach((elem: HTMLInputElement) => {
				if (elem !== e.target) {
					elem.readOnly = true
				}
			})

			document.querySelectorAll('.qtyBtn').forEach((elem: HTMLButtonElement) => {
				elem.disabled = true
			})

			document.querySelectorAll('.delete').forEach((elem: HTMLButtonElement) => {
				elem.disabled = true
			})

			clearTimeout(Cart.timeout)

			Cart.timeout = setTimeout(() => {

				const quantityInput = e.target as HTMLInputElement
				const floatValue = Number.parseFloat((e.target as HTMLInputElement).value)
				let newValue = Number.parseInt((e.target as HTMLInputElement).value)

				Cart.log(`[input] floatValue ${floatValue}`)
				Cart.log(`[input] newValue ${newValue}`)

				if (isNaN(floatValue) || !Number.isInteger(floatValue)) {

					document.querySelectorAll('.quantity-input').forEach((elem: HTMLInputElement) => {
						if (elem !== e.target) {
							elem.readOnly = false
						}
					})

					document.querySelectorAll('.qtyBtn').forEach((elem: HTMLButtonElement) => {
						elem.disabled = false
					})

					document.querySelectorAll('.delete').forEach((elem: HTMLButtonElement) => {
						elem.disabled = false
					})

					return
				}

				const basketId = unorderedListElem.dataset.basketid
				const price = Number.parseFloat(unorderedListElem.dataset.price)
				const regularPrice = Number.parseFloat(unorderedListElem.dataset.regularprice)
				const pricePoints = Number.parseInt(unorderedListElem.dataset.pricepoints)
				const oldValue = Number.parseInt(quantityInput.dataset.oldvalue)

				if (newValue < 0) {
					newValue = 0
				}

				if (newValue > 99) {
					alert(Cart.QUANTITY_TOO_HIGH)
					newValue = 99
				}

				if (newValue !== oldValue) {

					if (newValue <= 0) {
						Cart.onClickDeleteProduct({
							basketId: basketId,
							itemPosition: itemPosition,
							oldValue: oldValue.toString(),
						})
					}

					else {
						Cart.onUpdateQuantity({
							itemPosition: itemPosition,
							oldValue: oldValue,
							newValue: newValue,
							price: price,
							regularPrice: regularPrice,
							pricePoints: pricePoints,
						})
					}
				} else {

					document.querySelectorAll('.quantity-input').forEach((elem: HTMLInputElement) => {
						if (elem !== e.target) {
							elem.readOnly = false
						}
					})

					document.querySelectorAll('.qtyBtn').forEach((elem: HTMLButtonElement) => {
						elem.disabled = false
					})

					document.querySelectorAll('.delete').forEach((elem: HTMLButtonElement) => {
						elem.disabled = false
					})
				}

			}, Cart.TIME_TO_SAVE_AFTER_INPUT)
		})

		$('#cart-drawer .delete').on('click', (e) => {

			const unorderedListElem = e.target.closest('li.cart-item') as HTMLUListElement
			const itemPosition = Number.parseInt(unorderedListElem.dataset.position)
			const basketId = unorderedListElem.dataset.basketid
			const quantityInput = unorderedListElem.querySelector('input[name="quantity"]') as HTMLInputElement
			const oldValue = quantityInput.value

			Cart.onClickDeleteProduct({
				basketId: basketId,
				itemPosition: itemPosition,
				oldValue: oldValue
			})
		})

		$('#cart-drawer .undo').on('click', (e) => {

			const cartItemElem = e.target.closest('li.cart-item') as HTMLUListElement
			const itemPosition = Number.parseInt(cartItemElem.dataset.position)
			const oldBasketId = cartItemElem.dataset.oldbasketid
			const itemId = cartItemElem.dataset.itemid
			const invtId = cartItemElem.dataset.invtid
			const regularPrice = Number.parseFloat(cartItemElem.dataset.regularprice)
			const price = Number.parseFloat(cartItemElem.dataset.price)
			const pricePoints = Number.parseInt(cartItemElem.dataset.pricepoints)
			const extensionsGroups = cartItemElem.dataset.extensiongroups
			const extensions = cartItemElem.dataset.selectedextensions

			Cart.onClickUndoRemoval({
				oldBasketId: oldBasketId,
				itemPosition: itemPosition,
				itemId: itemId,
				invtId: invtId,
				regularPrice: regularPrice,
				price: price,
				pricePoints: pricePoints,
				extensionsGroups: extensionsGroups,
				extensions: extensions
			})
		})

		// Page-level handlers below are bound once; the per-line handlers above are
		// re-bound on every call because quickcart.ts re-renders the drawer lines.
		if (Cart.handlersBound) {
			return
		}
		Cart.handlersBound = true

		document.addEventListener('keydown', (e) => {
			if (e.key === 'Escape') {
				Cart.closeCartDrawer()
			}
		})

		$('#shoppingcart').on('click', (e) => {
			Cart.openCartDrawer()
		})

		$('#cart-drawer-close-button').on('click', (e) => {
			Cart.closeCartDrawer()
		})

		$('#cart-drawer-continue-shopping').on('click', (e) => {
			Cart.closeCartDrawer()
		})

		$('#cart-drawer-overlay').on('click', (event) => {
			const clickedOnOverlay = (event.target as HTMLElement).classList.contains('overlay-right')
			if (clickedOnOverlay) {
				Cart.closeCartDrawer()
			}
		})

		$('#edit-bag-button').on('click', (e) => {
			Cart.openCartDrawer()
		})

		document.getElementById('cart-drawer-ymal-items')?.addEventListener('click', (e) => {
			const target = e.target as HTMLElement
			const button = target.closest('.add-to-bag-btn') as HTMLButtonElement
			if (button) {
				const itemId = button.dataset.itemId
				const itemName = button.dataset.itemName
				const itemImage = button.dataset.itemImage
				const price = Number(button.dataset.itemPrice)
				const listPrice = Number(button.dataset.itemListPrice)
				
				if (itemId && itemName && itemImage && price && listPrice) {
					Cart.addYMALItemToCart(itemId, itemName, itemImage, price, listPrice, button)
				}
			}
		})
	}

	static setupCartDrawerYMALCarousel() {

		const Swiper = (window as any).Swiper;

		(window as any).swiperElements = []

		const commonParams = {
			controller: true,
			speed: 600,
			spaceBetween: 18,
			pagination: {
				clickable: true,
			},
		}

		const swiperElements = document.querySelectorAll("#cart-drawer .swiper")

		swiperElements.forEach((swiperElement) => {

			const swiper = new Swiper(swiperElement, {
				slidesPerView: "auto",
				navigation: {
					nextEl: "#cart-drawer .swiper-button-next",
					prevEl: "#cart-drawer .swiper-button-prev",
				},
				...(swiperElement.classList.contains("swiper-zoom") && { zoom: { toggle: true } }),
				...(swiperElement.classList.contains("loop") && { loop: true }),
				...(swiperElement.classList.contains("slides-one") && { slidesPerView: 1 }),
				...commonParams,
			});

			(window as any).swiperElements.push(swiper)
		})
	}

	static getGA4ItemsFromCartDrawer() {
		const ga4Items: GA4Item[] = []

		document.querySelectorAll('#cart-drawer-items .cart-item:not(.deleted)').forEach((elem: HTMLLIElement, index: number) => {

			const name = elem.dataset.itemname
			const invtId = elem.dataset.invtid
			const itemId = elem.dataset.itemid
			const alternateId = elem.dataset.alternateid
			const regularPrice = Number(elem.dataset.regularprice)
			const salePrice = Number(elem.dataset.price)
			const subscription = invtId.toUpperCase().includes('-SUB')
			const discount = subscription
				? 0
				: regularPrice - salePrice

			const quantity = Number.parseInt((elem.querySelector('input[name="quantity"]') as HTMLInputElement).value)

			const categoryDetails = CommonUtils.getInvtIDCategory(invtId, alternateId)

			let variant = ''

			elem.querySelectorAll('.cart-item-content-extension').forEach((elem: HTMLSpanElement, index: number) => {
				const extensionName = elem.dataset.extensionname
				variant += variant ? ';' : ''
				variant += extensionName
			})

			const ga4Item: GA4Item = {
				index: index,
				item_id: itemId,
				item_name: name,
				item_brand: Cart.siteDomainName,
				item_list_id: categoryDetails.categoryID,
				item_list_name: categoryDetails.category,
				item_category: categoryDetails.category,
				item_category2: categoryDetails.category2,
				item_category3: categoryDetails.category3,
				quantity: quantity,
				price: Math.min(regularPrice, salePrice),
				affiliation: Cart.siteName,
				discount: Number(discount.toFixed(2)),
				subscription: subscription ? 'yes' : 'no'
			}

			if (variant) {
				ga4Item.item_variant = variant
			}

			ga4Items.push(ga4Item)
		})

		return ga4Items
	}

	static setupGA4Items() {
		const ga4Items: GA4Item[] = Cart.getGA4ItemsFromCartDrawer();
		(window as any).GA4Items = ga4Items
	}

	static openCartDrawer() {

		// Only a closed → open transition counts as a view, so calls on an
		// already-open drawer (e.g. a double add) don't push duplicates
		if (!Cart.drawerOpen) {
			// Best-effort: an analytics failure must not stop the drawer from opening
			try {
				GA4Utils.trackViewCartEvent(Cart.getGA4ItemsFromCartDrawer())
			} catch (error) {
				console.error('[openCartDrawer] Failed to track view_cart event.', error)
			}
		}
		Cart.drawerOpen = true

		const gsap = (window as any).gsap
		const cartDrawerOverlay = document.getElementById('cart-drawer-overlay')
		const cartDrawerModalWrapper = document.getElementById('cart-drawer-content')
		const cartDrawerTween = gsap.timeline()
		cartDrawerOverlay.style.display = 'block';

        cartDrawerTween.fromTo (
            cartDrawerModalWrapper,
            { x: '100%' },
            {
                duration: 0.5,
                x: '0%',
                ease: 'power4.out',
                onStart: function () {
                    cartDrawerOverlay.style.pointerEvents = 'auto';
                }
            }
        );

		const basketIds = Array.from(document.querySelectorAll('#cart-drawer [data-basketid]'))
			.map((elem: HTMLElement) => elem.dataset.basketid)
			.filter((basketId) => basketId !== '' && basketId !== undefined)
		
		if (basketIds.length > 0) {
			document.getElementById('cart-drawer-checkout-button').style.display = 'flex'
			document.getElementById('cart-drawer-empty-cart-paragraph').style.display = 'none'
		}

		HAHAccessibility.trapFocus({
			container: '#cart-drawer-content',
			closeElement: '#cart-drawer-close-button',
			firstElementToFocus: '#cart-drawer-close-button',
			triggerHTMLElement: document.getElementById('shoppingcart'),
			delayFocus: 500
		})
	}

	static closeCartDrawer() {

		const isCheckoutPage = document.location.pathname.includes('checkout')
		const isPaymentPage = document.location.pathname.includes('payment')

		if ((isCheckoutPage || isPaymentPage) && Cart.itemLoading) {
			return
		}

		Cart.drawerOpen = false

		// Remove all deleted items from the cart
		const deletedItems = document.querySelectorAll('#cart-drawer-items .cart-item.deleted')
		deletedItems.forEach(item => item.remove())

		const gsap = (window as any).gsap
		const cartDrawerOverlay = document.getElementById('cart-drawer-overlay')
		const cartDrawerModalWrapper = document.getElementById('cart-drawer-content')
		const cartDrawerTween = gsap.timeline()

		cartDrawerTween.to(cartDrawerModalWrapper, {
            duration: 0.5,
            x: '100%',
            ease: 'power4.in',
            onComplete: function () {
            cartDrawerOverlay.style.display = 'none';
            cartDrawerOverlay.style.pointerEvents = 'none';
            }
         });

		HAHAccessibility.closeTrapFocus(
			document.getElementById('cart-drawer-close-button'),
			document.getElementById('shoppingcart'),
		)

		if (isCheckoutPage || isPaymentPage) {

			const ga4Items = Cart.getGA4ItemsFromCartDrawer()

			if (ga4Items.length === 0) {

				document.location.pathname = '/index.aspx'
			}
		}
	}

	static async onUpdateQuantity({
		itemPosition,
		newValue,
		oldValue,
		price,
		regularPrice,
		pricePoints
	}: {
		itemPosition: number
		newValue: number
		oldValue: number
		price: number
		regularPrice: number
		pricePoints: number
	}) {

		if (Cart.itemLoading) {
			return
		}

		Cart.log(`[onUpdateQuantity] itemPosition ${itemPosition}`)
		Cart.log(`[onUpdateQuantity] newValue ${newValue}`)
		Cart.log(`[onUpdateQuantity] oldValue ${oldValue}`)
		Cart.log(`[onUpdateQuantity] price ${price}`)
		Cart.log(`[onUpdateQuantity] pricePoints ${pricePoints}`)

		const cartItemElem = document.getElementById(`cart-item-${itemPosition}`)

		const formData = new FormData(document.getElementById('OCForm1') as HTMLFormElement)

		const viewState = encodeURIComponent(API.viewState || formData.get('__VIEWSTATE') as string)
		const viewStateGenerator = encodeURIComponent(formData.get('__VIEWSTATEGENERATOR') as string)
		const viewStateEncrypted = encodeURIComponent(formData.get('__VIEWSTATEENCRYPTED') as string)

		const quantityInput = cartItemElem.querySelector('#cart-drawer input[name="quantity"]') as HTMLInputElement
		const basketIds = Array.from(document.querySelectorAll('#cart-drawer [data-basketid], #cart-drawer [data-oldbasketid]')).map((elem: HTMLLIElement) => elem.dataset.basketid || elem.dataset.oldbasketid || undefined)
		const productIds = Array.from(document.querySelectorAll('#cart-drawer [data-invtid]')).map((elem: HTMLLIElement) => elem.dataset.invtid)
		const quantities = Array.from(document.querySelectorAll('#cart-drawer input[name="quantity"]'))
			.map((elem: HTMLInputElement) => elem.value)
			.filter((elem) => elem !== '0')

		const cartItems: {
			basketId: string
			productId: string
			quantity: number
		}[] = []

		Cart.log(`[onUpdateQuantity] Building the cart items array...`)

		for (let i = 0; i < basketIds.length; i++) {
			const basketId = basketIds[i]
			const productId = productIds[i]
			const quantity = quantities[i]

			Cart.log(`[onUpdateQuantity] (${i + 1}) basketId ${basketId}`)
			Cart.log(`[onUpdateQuantity] (${i + 1}) productId ${productId}`)
			Cart.log(`[onUpdateQuantity] (${i + 1}) quantity ${quantity}`)

			if (i === itemPosition - 1) {

				Cart.updateItemQuantity(itemPosition, newValue.toString())

				cartItems.push({
					basketId: basketId,
					productId: productId,
					quantity: newValue
				})
			}

			else {
				cartItems.push({
					basketId: basketId,
					productId: productId,
					quantity: Number.parseInt(quantity)
				})
			}
		}

		Cart.toggleItemLoading(itemPosition)
		
		let result: CartResponse

		try {
			result = await API.updateCartQuantities({
				viewState: viewState,
				viewStateGenerator: viewStateGenerator,
				viewStateEncrypted: viewStateEncrypted,
				cartItems: cartItems
			})
		} catch (err) {
			console.error(err)

			Cart.updateItemQuantity(itemPosition, oldValue.toString())
		} finally {
			Cart.toggleItemLoading(itemPosition)
		}

		if (!result) {

			// Restore to the old quantity value
			Cart.updateItemQuantity(itemPosition, oldValue.toString())

			console.error('[onClickUpdateQuantity] Failed to update cart quantities.')
			return
		}

		quantityInput.dataset.oldvalue = newValue.toString()


		const currency = result.currency as 'USD'
		const subtotal = result.subtotal
		const subtotalPoints = result.subtotalPoints
		const promoCodeDiscount = result.promoCodeDiscount
		const flatRatePromoDiscount = result.flatRatePromoDiscount
		const total = result.total
		const newCartItems = result.newCartItems

		Cart.log(`[onClickUpdateQuantity] currency ${currency}`)
		Cart.log(`[onClickUpdateQuantity] subtotal ${subtotal}`)
		Cart.log(`[onClickUpdateQuantity] subtotalPoints ${subtotalPoints}`)
		Cart.log(`[onClickUpdateQuantity] promoCodeDiscount ${promoCodeDiscount}`)
		Cart.log(`[onClickUpdateQuantity] flatRatePromoDiscount ${flatRatePromoDiscount}`)
		Cart.log(`[onClickUpdateQuantity] newCartItems`, newCartItems)

		Cart.updateItemTotal({
			itemPosition: itemPosition,
			quantity: newValue,
			regularPrice: regularPrice,
			price: price,
			pricePoints: pricePoints,
			currency: currency
		})

		Cart.updateCartTotals({
			subtotal: subtotal,
			subtotalPoints: subtotalPoints,
			total: total,
			promoCodeDiscount: promoCodeDiscount,
			flatRatePromoDiscount: flatRatePromoDiscount,
			currency: currency
		})

		Cart.saveCartInSalesforce(newCartItems)

		// If one or more items were added to the cart in another tab/page...
		if (newCartItems.length > cartItems.length) {

			// Reload the page
			document.location.reload()
		}
		
		// If it's on the checkout or payment page...
		Cart.setShippingMethodAndGetCostsAndUpdateCheckoutUI()
	}

	static async onClickDeleteProduct({
		basketId,
		itemPosition,
		oldValue
	}: {
		basketId: string
		itemPosition: number
		oldValue: string
	}) {

		if (Cart.itemLoading) {
			return
		}

		Cart.log(`[onClickDeleteProduct] Removing product from cart...`)
		Cart.log(`[onClickDeleteProduct] basketId: ${basketId}`)
		Cart.log(`[onClickDeleteProduct] itemPosition: ${itemPosition}`)
		Cart.log(`[onClickDeleteProduct] oldValue: ${oldValue}`)

		const cartItemElem = document.getElementById(`cart-item-${itemPosition}`)
		const quantityInput = cartItemElem.querySelector('input[name="quantity"]') as HTMLInputElement
		const cartDrawerCloseButton = document.getElementById('cart-drawer-close-button') as HTMLButtonElement
		
		// Checkout/payment page elements
		const checkoutCartItemElem = document.getElementById(`checkout-cart-item-${itemPosition}`)
		const bedShippingNoticeElem = document.getElementById('bedshippingnotice') as HTMLDivElement

		const cartHasMattressItem = Cart.hasMattressItem()

		Cart.toggleItemLoading(itemPosition)
		Cart.updateItemQuantity(itemPosition, '0')

		// Disable close button
		cartDrawerCloseButton.disabled = true

		let result: CartResponse

		try {
			result = await API.deleteItemFromCart({
				basketId: basketId,
			})
		} catch (err) {
			console.error(err)
			Cart.updateItemQuantity(itemPosition, oldValue)
		} finally {
			Cart.toggleItemLoading(itemPosition)

			// Enable close button
			cartDrawerCloseButton.disabled = false
		}

		if (!result) {
			console.error('Failed to delete product from cart.')
			return
		}
		
		const subtotal = result.subtotal
		const subtotalPoints = result.subtotalPoints
		const newCartItems = result.newCartItems
		const flatRatePromoDiscount = result.flatRatePromoDiscount
		const promoCodeDiscount = result.promoCodeDiscount
		const total = result.total

		Cart.log(`[onClickDeleteProduct] Removed product from cart!`)

		Cart.updateCartTotals({
			subtotal: subtotal,
			subtotalPoints: subtotalPoints,
			flatRatePromoDiscount: flatRatePromoDiscount,
			promoCodeDiscount: promoCodeDiscount,
			total: total,
			currency: 'USD'
		})

		// Add class "deleted" to UL
		cartItemElem.classList.add('deleted')

		if (checkoutCartItemElem) {
			checkoutCartItemElem.classList.add('deleted')
		}

		Cart.checkIfCartHasMattressItemAndDoWhatIsNeeded()

		// Remove the data-basketid property from the element (this basketid is no longer valid since the product was removed)
		// document.querySelector(`[value="${basketId}"]`).setAttribute('value', '')
		document.querySelectorAll(`[data-basketid="${basketId}"]`).forEach((elem) => {
			elem.setAttribute('data-oldbasketid', basketId)
			elem.removeAttribute('data-basketid')
		})

		// Get remaining basket ids
		const basketIds = Array.from(document.querySelectorAll('[data-basketid]'))
			.map((elem: HTMLElement) => elem.dataset.basketid)
			.filter((basketId) => basketId !== '')

		// If the cart is empty...
		if (basketIds.length === 0) {
			document.getElementById('cart-drawer-empty-cart-paragraph').style.display = 'block'
			// document.getElementById('DIVcartSumItemsList').style.display = 'none'
			document.getElementById('cart-drawer-checkout-button').style.display = 'none'
		}

		const oldQuantity = quantityInput.dataset.oldvalue

		const name = cartItemElem.dataset.itemname
		const invtId = cartItemElem.dataset.invtid
		const itemId = cartItemElem.dataset.itemid
		const alternateId = cartItemElem.dataset.alternateid
		const regularPrice = Number(cartItemElem.dataset.regularprice)
		const salePrice = Number(cartItemElem.dataset.price)
		const subscription = invtId.toUpperCase().includes('-SUB')
		const discount = subscription ? 0 : regularPrice - salePrice

		const categoryDetails = CommonUtils.getInvtIDCategory(invtId, alternateId)

		let variant = ''
		cartItemElem.querySelectorAll('.cart-item-content-extension').forEach((elem: HTMLSpanElement) => {
			const extensionName = elem.dataset.extensionname
			variant += variant ? ';' : ''
			variant += extensionName
		})

		// Create a proper GA4Item with all available information
		const ga4RemovedItem: GA4Item = {
			index: itemPosition - 1,
			item_id: itemId,
			item_name: name,
			item_brand: Cart.siteDomainName,
			item_list_id: categoryDetails.categoryID,
			item_list_name: categoryDetails.category,
			item_category: categoryDetails.category,
			item_category2: categoryDetails.category2,
			item_category3: categoryDetails.category3,
			quantity: Number.parseInt(oldQuantity),
			price: Math.min(regularPrice, salePrice),
			affiliation: Cart.siteName,
			discount: Number(discount.toFixed(2)),
			subscription: subscription ? 'yes' : 'no'
		}

		if (variant) {
			ga4RemovedItem.item_variant = variant
		}

		// Track the remove from cart event with complete item information
		GA4Utils.trackRemoveFromCartEvent([ga4RemovedItem])

		Cart.saveCartInSalesforce(newCartItems)

		const oldCartItemsCount = document.querySelectorAll('li.cart-item').length

		// If one or more items were added to the cart in another tab/page...
		if (newCartItems.length > oldCartItemsCount) {

			// Reload the page
			document.location.reload()
		}

		// If it's on the checkout or payment page...
		Cart.setShippingMethodAndGetCostsAndUpdateCheckoutUI()
	}

	static async onClickUndoRemoval({
		oldBasketId,
		itemPosition,
		itemId,
		invtId,
		regularPrice,
		price,
		pricePoints,
		extensionsGroups,
		extensions
	}: {
		oldBasketId: string
		itemPosition: number
		itemId: string
		invtId: string
		regularPrice: number
		price: number
		pricePoints: number
		extensionsGroups: string
		extensions: string
	}) {

		if (Cart.itemLoading) {
			return
		}

		Cart.log(`[onClickUndoRemoval] Adding product back to cart...`)
		Cart.log(`[onClickUndoRemoval] oldBasketId: ${oldBasketId}`)
		Cart.log(`[onClickUndoRemoval] itemPosition: ${itemPosition}`)
		Cart.log(`[onClickUndoRemoval] itemId: ${itemId}`)
		Cart.log(`[onClickUndoRemoval] invtId: ${invtId}`)
		Cart.log(`[onClickUndoRemoval] price: ${price}`)
		Cart.log(`[onClickUndoRemoval] extensionsGroups: ${extensionsGroups}`)
		Cart.log(`[onClickUndoRemoval] extensions: ${extensions}`)

		const isCheckoutPage = document.location.pathname.includes('checkout')
		const isPaymentPage = document.location.pathname.includes('payment')

		const cartItemElem = document.getElementById(`cart-item-${itemPosition}`)
		const checkoutCartItemElem = document.getElementById(`checkout-cart-item-${itemPosition}`)

		const quantityInput = cartItemElem.querySelector(`input[name="quantity"]`) as HTMLInputElement

		const extensionsSplited = (extensions || '').split(';')
		const extensionsArray = extensionsSplited[0] !== '' ? extensionsSplited : []

		const oldQuantity = quantityInput.dataset.oldvalue

		Cart.toggleItemLoading(itemPosition)
		Cart.toggleItemDeleted(itemPosition)
		Cart.updateItemQuantity(itemPosition, oldQuantity)

		// Hide "empty cart" message...
		document.getElementById('cart-drawer-empty-cart-paragraph').style.display = 'none'

		let result: CartResponse

		try {
			result = await API.addOneItemToCart({
				itemId: itemId,
				extensionsGroups: extensionsGroups,
				extensions: extensionsArray,
				quantity: oldQuantity
			})
		} catch (err) {
			console.error(err)
			Cart.toggleItemDeleted(itemPosition)
			Cart.updateItemQuantity(itemPosition, '0')
		} finally {
			Cart.toggleItemLoading(itemPosition)
		}

		const basketIds = result.basketIds
		const subtotal = result.subtotal
		const subtotalPoints = result.subtotalPoints
		const flatRatePromoDiscount = result.flatRatePromoDiscount
		const promoCodeDiscount = result.promoCodeDiscount
		const newCartItems = result.newCartItems
		const total = result.total

		// Show "empty cart" message if the cart is empty
		if (basketIds.length === 0) {
			document.getElementById('cart-drawer-empty-cart-paragraph').style.display = 'block'
		}

		Cart.log(`[onClickUndoRemoval] newCartItems`, newCartItems)

		// Find the index of the added item
		const addedItemIndex = newCartItems.findIndex(elem => elem.invtId === invtId)

		// Get the new basket id
		const basketId = basketIds[addedItemIndex]

		if (!basketIds || !subtotal || !subtotalPoints || !total) {
			console.error(`[onClickUndoRemoval] Something went wrong adding item back to cart.`)
			console.error(`[onClickUndoRemoval] basketId: ${basketId}`)
			console.error(`[onClickUndoRemoval] subtotal: ${subtotal}`)
			console.error(`[onClickUndoRemoval] subtotalPoints: ${subtotalPoints}`)
			console.error(`[onClickUndoRemoval] total: ${total}`)
			return
		}

		Cart.log(`[onClickUndoRemoval] Added product back to cart!`)
		Cart.log(`[onClickUndoRemoval] newCartItems.length ${newCartItems.length}`)
		Cart.log(`[onClickUndoRemoval] basketId: ${basketId}`)

		Cart.updateItemTotal({
			itemPosition: itemPosition,
			quantity: Number.parseInt(oldQuantity),
			regularPrice: regularPrice,
			price: price,
			pricePoints: pricePoints,
			currency: 'USD'
		})

		Cart.updateCartTotals({
			subtotal: subtotal,
			subtotalPoints: subtotalPoints,
			flatRatePromoDiscount: flatRatePromoDiscount,
			promoCodeDiscount: promoCodeDiscount,
			total: total,
			currency: 'USD'
		})

		// Add the basket id to the input
		// document.querySelectorAll('input[name="basketID"]')[itemPosition - 1].setAttribute('value', basketId)

		// Removed the old basket id (not needed anymore) and assign the new basket id
		document.querySelectorAll(`[data-oldbasketid="${oldBasketId}"`).forEach((elem) => {
			elem.removeAttribute('data-oldbasketid')
			elem.setAttribute('data-basketid', basketId)
		})

		// Toggle items visibility in header cart dropdown
		if (document.getElementById('cart-drawer-empty-cart-paragraph').style.display) {
			document.getElementById('cart-drawer-empty-cart-paragraph').style.display = 'none'
			// document.getElementById('DIVcartSumItemsList').style.display = 'unset'
			document.getElementById('cart-drawer-checkout-button').style.display = 'flex'
		}

		// Show item in the checkout cart UI
		if (isCheckoutPage || isPaymentPage) {
			checkoutCartItemElem.classList.remove('deleted')
		}

		Cart.checkIfCartHasMattressItemAndDoWhatIsNeeded()

		const ga4Items = (window as any).GA4Items

		// Update ga4Items array with new basket id
		ga4Items[basketId] = {
			...ga4Items[oldBasketId],
			quantity: Number.parseInt(oldQuantity)
		}

		// Delete the old basket id from the ga4Items array
		delete ga4Items[oldBasketId]

		// Track the add_to_cart event
		const ga4Item = ga4Items[basketId]
		GA4Utils.trackAddToCartEvent([ga4Item], {
			id: ga4Item.item_id,
			name: ga4Item.item_name,
			category: ga4Item.item_category,
			value: ga4Item.price,
		})

		Cart.saveCartInSalesforce(newCartItems)

		const oldCartItemsCount = document.querySelectorAll('li.cart-item').length

		// If one or more items were added to the cart in another tab/page...
		if (newCartItems.length > oldCartItemsCount) {

			// Reload the page
			document.location.reload()
		}
	}

	static toggleItemLoading(itemPosition: number | string) {

		const isCheckoutPage = document.location.pathname.includes('checkout')
		const isPaymentPage = document.location.pathname.includes('payment')

		const unorderedListElem = document.getElementById(`cart-item-${itemPosition}`)

		// Checkout/payment page elements
		const loaderItemTotal = document.getElementById(`loader-price-total-${itemPosition}`)
		const itemTotalCash = document.getElementById(`checkout-price-total-cash-${itemPosition}`)
		// const itemTotalPoints = document.getElementById(`checkout-price-total-points-${itemPosition}`)

		if (Cart.itemLoading) {
			Cart.itemLoading = false

			// Remove class "loading" from UL elements
			document.querySelectorAll('.cart-item').forEach((elem) => elem.classList.remove('loading'))
			document.querySelectorAll('.modal-cart-item').forEach((elem) => elem.classList.remove('loading'))

			// Enable quantity inputs
			document.querySelectorAll('.quantity-input').forEach((elem: HTMLInputElement) => {
				elem.readOnly = false
			})

			// Enable increment/decrement buttons
			document.querySelectorAll('#cart-drawer .quantity-increase, #cart-drawer .quantity-decrease').forEach((elem: HTMLButtonElement) => {
				elem.disabled = false
			})

			// Enable delete buttons
			document.querySelectorAll('.delete').forEach((elem: HTMLButtonElement) => {
				elem.disabled = false
			})

			if (isCheckoutPage || isPaymentPage) {

				// Hide loader in the item total
				if (loaderItemTotal) {
					loaderItemTotal.style.setProperty('display', 'none', 'important');
				}

				// Show price in the item total (cash)
				if (itemTotalCash) {
					itemTotalCash.style.setProperty('display', '');
				}

				// Show price in the item total (points)
				// TODO: Detect if cash or points is being used
				// if (itemTotalPoints) {
				// 	itemTotalPoints.style.setProperty('display', '');
				// }
			}

		} else {
			Cart.itemLoading = true

			// Add class "loading" to UL
			unorderedListElem.classList.add('loading')

			// Disable quantity inputs
			document.querySelectorAll('.quantity-input').forEach((elem: HTMLInputElement) => {
				elem.readOnly = true
			})

			// Disable increment/decrement buttons
			document.querySelectorAll('#cart-drawer .quantity-increase, #cart-drawer .quantity-decrease').forEach((elem: HTMLButtonElement) => {
				elem.disabled = true
			})

			// Disable delete buttons
			document.querySelectorAll('.delete').forEach((elem: HTMLButtonElement) => {
				elem.disabled = true
			})

			if (isCheckoutPage || isPaymentPage) {

				// Show loader in the item total
				if (loaderItemTotal) {
					loaderItemTotal.style.setProperty('display', 'flex', 'important');
				}

				// Hide price in the item total (cash)
				if (itemTotalCash) {
					itemTotalCash.style.setProperty('display', 'none', 'important');
				}

				// Hide price in the item total (points)
				// TODO: Detect if cash or points is being used
				// if (itemTotalPoints) {
				// 	itemTotalPoints.style.setProperty('display', 'none', 'important');
				// }
			}
		}
	}

	static toggleItemDeleted(itemPosition: number | string) {

		const cartItemElem = document.getElementById(`cart-item-${itemPosition}`)
		// const cartItemElemInHeader = document.getElementById(`modal-item-${itemPosition}`)

		cartItemElem.classList.toggle('deleted')
		// cartItemElemInHeader.classList.toggle('deleted')
	}

	static toggleShippingCostLoading() {

		const loaderShipping = document.getElementById('loader-shipping')
		const shippingCostPriceElem = document.getElementById('SPANcheckoutCartCuryTotPremFrt')

		if (Cart.shippingCostLoading) {
			Cart.shippingCostLoading = false

			// Hide loader in the shipping cost
			if (loaderShipping) { 
				loaderShipping.style.setProperty('display', 'none', 'important');
			}
	
			// Show price in the shipping cost
			if (shippingCostPriceElem) {
				shippingCostPriceElem.style.setProperty('display', '');
			}
		} else {
			Cart.shippingCostLoading = true

			// Show loader in the shipping cost
			if (loaderShipping) {
				loaderShipping.style.setProperty('display', 'flex', 'important');
			}

			// Hide price in the shipping cost
			if (shippingCostPriceElem) {
				shippingCostPriceElem.style.setProperty('display', 'none', 'important');
			}
		}
	}

	static updateItemQuantity(itemPosition: number, newQuantity: string) {

		// Drawer and header elemenets
		const cartItemElem = document.getElementById(`cart-item-${itemPosition}`)
		const quantityInput = cartItemElem.querySelector(`input[name="quantity"]`) as HTMLInputElement
		const bubbleCountSpanElem = document.getElementById('bubble-cnt') as HTMLSpanElement
		const bubbleCountWrapper = document.querySelector('#cartSumQty') as HTMLSpanElement
		const cartDrawerH2 = document.querySelector('#cart-drawer-head-h2') as HTMLHeadingElement
		const cartDrawerH2Text = cartDrawerH2.innerHTML.split('(')[0].trim()

		// Checkout elements
		const checkoutItems = document.querySelectorAll('.checkout-summary-items')

		let newBubbleCount = 0

		// Update the quantity in the quantity input
		quantityInput.setAttribute('value', newQuantity)
		quantityInput.value = newQuantity

		// Calculate new total count
		document.querySelectorAll('.quantity-input').forEach((elem: HTMLInputElement) => {
			newBubbleCount += Number.parseInt(elem.value)
		})

		// Refresh bubble count element and cart drawer h2 with total amount of items
		if (newBubbleCount > 0) {
			bubbleCountWrapper.style.display = ''
			bubbleCountSpanElem.innerHTML = `${newBubbleCount}`
			cartDrawerH2.innerHTML = `${cartDrawerH2Text} (${newBubbleCount})`
			Cart.updateCartDrawerItemCount(newBubbleCount)
		} else {
			bubbleCountWrapper.style.display = 'none'
			bubbleCountSpanElem.innerHTML = ''
			cartDrawerH2.innerHTML = cartDrawerH2Text
			Cart.updateCartDrawerItemCount(0)
		}

		checkoutItems.forEach((elem: HTMLDivElement, index: number) => {

			// const price = Number.parseFloat(elem.dataset.price)
			// const pricePoints = Number.parseFloat(elem.dataset.pricepoints)

			// const newTotalCash = (Number(newQuantity) * price).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
			// const newTotalPoints = Number(newQuantity) * pricePoints

			if (index === (itemPosition - 1)) {

				const quantityElement = elem.querySelector('.checkout-item-quantity')
				// const totalCashElement = elem.querySelector('.price-cash .checkout-item-total')
				// const totalPointsElement = elem.querySelector('.price-points .checkout-item-total')

				// Update item quantity
				quantityElement.innerHTML = newQuantity

				// Update item total
				// totalCashElement.innerHTML = newTotalCash

				// if (totalPointsElement) {
				// 	totalPointsElement.innerHTML = `${newTotalPoints} Points`
				// }
			}
		})
	}

	static updateItemTotal({
		itemPosition,
		quantity,
		regularPrice,
		price,
		pricePoints,
		currency = 'USD'
	}: {
		itemPosition: number,
		quantity: number,
		regularPrice: number,
		price: number,
		pricePoints: number,
		currency: 'USD'
	}) {

		const cartItemElem = document.getElementById(`cart-item-${itemPosition}`)
		const totalRegularElem = cartItemElem.querySelector('.regular-price') as HTMLParagraphElement
		const totalElem = cartItemElem.querySelector('.price') as HTMLParagraphElement
		// const totalPointsElem = cartItemElem.querySelector('.price') as HTMLParagraphElement

		const checkoutItems = document.querySelectorAll('.checkout-summary-items')

		Cart.log(`[updateItemTotal] itemPosition ${itemPosition}`)
		Cart.log(`[updateItemTotal] quantity ${quantity}`)
		Cart.log(`[updateItemTotal] regularPrice ${regularPrice}`)
		Cart.log(`[updateItemTotal] price ${price}`)

		if(totalRegularElem && totalRegularElem.textContent && totalRegularElem.textContent.trim() !== ''){
			totalRegularElem.innerHTML = `${Number.parseFloat((quantity * regularPrice).toFixed(2)).toLocaleString('en-US', { style: 'currency', currency: currency })}`
		}
		totalElem.innerHTML = `${Number.parseFloat((quantity * price).toFixed(2)).toLocaleString('en-US', { style: 'currency', currency: currency })}`
		// totalPointsElem.innerHTML = `${(quantity * pricePoints).toLocaleString('en-US')} Points`

		checkoutItems.forEach((elem: HTMLDivElement, index: number) => {

			const price = Number.parseFloat(elem.dataset.price)
			const pricePoints = Number.parseFloat(elem.dataset.pricepoints)

			const newTotalCash = (Number(quantity) * price).toLocaleString('en-US', { style: 'currency', currency: 'USD' })
			const newTotalPoints = Number(quantity) * pricePoints

			if (index === (itemPosition - 1)) {

				const totalCashElement = elem.querySelector('.price-cash .checkout-item-total')
				const totalPointsElement = elem.querySelector('.price-points .checkout-item-total')

				totalCashElement.innerHTML = newTotalCash

				if (totalPointsElement) {
					totalPointsElement.innerHTML = `${newTotalPoints} Points`
				}
			}
		})
	}

	static updateDiscountBanner(flatRatePromoDiscount: number) {
		const discountBanner = document.getElementById('cart-drawer-discount-banner');
		const discountValueSpan = discountBanner?.querySelector('#cartDrawerDiscValue');
		
		if (!discountBanner || !discountValueSpan) return;

		if (flatRatePromoDiscount > 0) {
			discountValueSpan.innerHTML = flatRatePromoDiscount.toLocaleString('en-US', { style: 'currency', currency: 'USD' });
			discountBanner.style.display = 'block';
		} else {
			discountBanner.style.display = 'none';
		}
	}

	static updateCartTotals({
		subtotal,
		subtotalPoints,
		total,
		promoCodeDiscount,
		flatRatePromoDiscount,
		currency = 'USD'
	}: {
		subtotal: string
		subtotalPoints: string
		total: string
		promoCodeDiscount: string,
		flatRatePromoDiscount: number,
		currency: 'USD'
	}) {

		const isBMSMPromoActive = (window as any).isBMSMPromoActive

		// Elements used when there isn't "Buy More Save More" (BMSM) promo discount
		const subtotalElem = document.getElementById('subtotalInUI')
		// const subtotalHeaderElem = document.getElementById('hdCashSubtotal')
		// const subtotalPointsElem = document.getElementById('subtotalPointsInUI')
		// const subtotalPointsHeaderElem = document.getElementById('hdPointsSubtotal')

		// Elements used when there is "Buy More Save More" (BMSM) promo discount
		const cartTotalElem = document.getElementById('carttotalInUI')
		// const cartTotalHeaderElem = document.getElementById('hdCartTotal')
		const discountElem = document.getElementById('discountInUI')
		// const discountHeaderElem = document.getElementById('hdDiscount')
		const totalElem = document.getElementById('totalInUI')
		// const totalHeaderElem = document.getElementById('hdTotal')
		// const cartPointsSubtotalElem = document.getElementById('cartPointsSubtotal')
		// const cartPointsSubtotalHeaderElem = document.getElementById('hdPointsSubtotalDiscount')

		// Checkout/payment page elements
		const checkoutSubtotalElem = document.getElementById('SPANcheckoutCartCuryTotMerch')
		const checkoutTotalElem = document.getElementById('SPANcheckoutCartCuryTotOrd')
		const cashDiscountNoteValueElem = document.getElementById('cashDiscNoteValue')
		const pointsDiscountNoteValueElem = document.getElementById('pointsDiscNoteValue')

		const subtotalString = `${Number.parseFloat(subtotal).toLocaleString('en-US', { style: 'currency', currency: currency }) || ''}`
		const totalString = `${Number.parseFloat(total).toLocaleString('en-US', { style: 'currency', currency: currency }) || ''}`

		// Update the elements
		subtotalElem.innerHTML = subtotalString
		// subtotalHeaderElem.innerHTML = `${Number.parseFloat(subtotal).toLocaleString('en-US', { style: 'currency', currency: currency }) || ''}`
		// subtotalPointsElem.innerHTML = subtotalPoints ? `${Number.parseInt(subtotalPoints).toLocaleString('en-US')} Points` : ''
		// subtotalPointsHeaderElem.innerHTML = subtotalPoints ? `${Number.parseInt(subtotalPoints).toLocaleString('en-US')} Points` : ''
		// cartPointsSubtotalElem.innerHTML = subtotalPoints ? `${Number.parseInt(subtotalPoints).toLocaleString('en-US')} Points` : ''
		// cartPointsSubtotalHeaderElem.innerHTML = subtotalPoints ? `${Number.parseInt(subtotalPoints).toLocaleString('en-US')} Points` : ''

		if (checkoutSubtotalElem) {
			checkoutSubtotalElem.innerHTML = subtotalString
		}

		if (checkoutTotalElem) {
			checkoutTotalElem.innerHTML = totalString
		}

		if (cashDiscountNoteValueElem) {
			const discountNoteTotalValue = (Number.parseFloat(promoCodeDiscount) + flatRatePromoDiscount)
			cashDiscountNoteValueElem.innerHTML = discountNoteTotalValue.toLocaleString('en-US', { style: 'currency', currency: currency })
		}

		if (isBMSMPromoActive) {

			const promoProps = (window as any).promoPropsObj

			// Calculate new discount for BMSM promo
			let newDiscount = promoProps.discount || 0

			const subtotalNumber = Number.parseFloat(subtotal)

			let promoTiersLenght = promoProps.promoTiers.length
			if (subtotalNumber < promoProps.promoTiers[0].minTotal) {
				newDiscount = 0
			} else if (subtotalNumber > promoProps.promoTiers[promoTiersLenght - 1].minTotal) {
				newDiscount = promoProps.promoTiers[promoTiersLenght - 1].dollarOff
			} else {
				for (let i = 0; i < promoTiersLenght - 1; i++) {
					if ((subtotalNumber > promoProps.promoTiers[i].minTotal) && (subtotalNumber < promoProps.promoTiers[i + 1].minTotal)) {
						newDiscount = promoProps.promoTiers[i].dollarOff
					}
				}
			}

			promoProps.subTotal = subtotalNumber
			promoProps.discount = newDiscount
			promoProps.total = subtotalNumber - newDiscount

			if (newDiscount > 0) {

				const cartTotalString = `${Number.parseFloat(subtotal).toLocaleString('en-US', { style: 'currency', currency: currency }) || ''}`

				const discountString = newDiscount > 0
					? `-${newDiscount.toLocaleString('en-US', { style: 'currency', currency: currency })}`
					: ''

				const totalString = `${Number.parseFloat((subtotalNumber - newDiscount).toFixed(2)).toLocaleString('en-US', { style: 'currency', currency: currency }) || ''}`

				// Update subtotals (with discount)
				cartTotalElem.innerHTML = cartTotalString
				discountElem.innerHTML = discountString
				totalElem.innerHTML = totalString

				// Hide totals without discount
				$('#cartULNoDiscount').hide()
				$('#hdULNoDiscount').hide()

				// Show totals with discount
				$('#cartULDiscount').show()
				$('#hdULDiscount').show()

			} else {

				// Hide totals with discount
				$('#cartULDiscount').hide()
				$('#hdULDiscount').hide()

				// Show totals without discount
				$('#cartULNoDiscount').show()
				$('#hdULNoDiscount').show()
			}
		} else {

			// Hide totals with discount
			$('#cartULDiscount').hide()
			$('#hdULDiscount').hide()

			// Show totals without discount
			$('#cartULNoDiscount').show()
			$('#hdULNoDiscount').show()
		}
		// Update discount banner
		Cart.updateDiscountBanner(flatRatePromoDiscount);
	}

	static async setShippingMethodAndGetCostsAndUpdateCheckoutUI() {

		const isCheckoutPage = document.location.pathname.includes('checkout')
		const isPaymentPage = document.location.pathname.includes('payment')
		
		// If it's on the checkout or payment page...
		if (isCheckoutPage || isPaymentPage) {

			Cart.toggleShippingCostLoading()
			
			// Checkout page elements
			const shippingCountryElem = document.getElementById('addressUI_ddlShipAddrCountry') as HTMLSelectElement
			const usShippingMethodSelectedElem = document.querySelector('#ulUSDeloptions [role="radio"][aria-checked="true"]') as HTMLLIElement
			const intlShippingMethodSelectedElem = document.querySelector('#ulIntlDeloptions [role="radio"][aria-checked="true"]') as HTMLLIElement

			// Payment page elements
			const orderReviewElement = document.getElementById('order-review') 

			const cartHasMattressItem = Cart.hasMattressItem()
			
			const shippingCountry = isCheckoutPage 
				? shippingCountryElem.value
				: orderReviewElement.dataset.shippingcountry

			let usShippingMethodSelected = 'BESTWAY'
			let intlShippingMethodSelected = 'BESTWAY'

			if (!cartHasMattressItem) {
				if (usShippingMethodSelectedElem) {
					usShippingMethodSelected = usShippingMethodSelectedElem.id.replace('shipOption', '')
				}
				
				if (intlShippingMethodSelectedElem) {
					intlShippingMethodSelected = intlShippingMethodSelectedElem.id.replace('shipOption', '')
				}
			}

			const shippingMethodSelected = shippingCountry === 'US'
				? usShippingMethodSelected
				: intlShippingMethodSelected

			try {

				// Get new shipping cost
				const result = await API.setShippingMethodAndGetCostsAndTotals(shippingMethodSelected)
	
				Cart.log(`[setShippingMethodAndGetCostsAndUpdateCheckoutUI] subtotal`, result.subtotal)
				Cart.log(`[setShippingMethodAndGetCostsAndUpdateCheckoutUI] tax`, result.tax)
				Cart.log(`[setShippingMethodAndGetCostsAndUpdateCheckoutUI] total`, result.total)
				Cart.log(`[setShippingMethodAndGetCostsAndUpdateCheckoutUI] shippingCosts`, result.shippingCosts)
	
				// Update shipping cost in the cart in the UI
				const newShippingCost = result.shippingCosts[shippingMethodSelected]
				const shippingCostElem = document.getElementById('SPANcheckoutCartCuryTotPremFrt')
				const shippingCostString = newShippingCost.toLocaleString('en-US', { style: 'currency', currency: 'USD' })
				shippingCostElem.innerHTML = shippingCostString
	
				// Update tax cost in the cart in the UI
				const newTaxCost = result.tax
				const taxCostElem = document.getElementById('SPANcheckoutCartCuryTotTax')
				const taxCostString = newTaxCost.toLocaleString('en-US', { style: 'currency', currency: 'USD' })
				taxCostElem.innerHTML = taxCostString
	
				// Update total in the cart in the UI
				const newTotal = result.total
				const totalElem = document.getElementById('SPANcheckoutCartCuryTotOrd')
				totalElem.innerHTML = newTotal.toLocaleString('en-US', { style: 'currency', currency: 'USD' })
	
				if (isCheckoutPage) {
					
					// Update shipping cost in the shipping methods section in the UI
					const shippingMethodsIds = Object.keys(result.shippingCosts)
					for (const shippingMethodId of shippingMethodsIds) {
						const shippingMethodCost = result.shippingCosts[shippingMethodId]
						const shippingMethodCostElem = document.getElementById(`span${shippingMethodId}`)
						const shippingMethodCostString = shippingMethodCost.toLocaleString('en-US', { style: 'currency', currency: 'USD' })
						shippingMethodCostElem.innerHTML = shippingMethodCostString
	
						// When a mattress item is on the cart, 'SPANbestway' is rendered instead of 'spanBESTWAY'
						if (shippingMethodId === 'BESTWAY') {
							const shippingMethodCostElem = document.getElementById('span_initial_price_us')
							shippingMethodCostElem.innerHTML = shippingMethodCostString
						}
					}
				}

				return result

			} finally {
				Cart.toggleShippingCostLoading()
			}
		}
	}

	static hasMattressItem() {
		
		const cartItems = document.querySelectorAll('#cart-drawer .cart-item:not(.deleted)') as NodeListOf<HTMLLIElement>

		for (let i = 0; i < cartItems.length; i++) {
			const cartItemElem = cartItems[i]
			const invtId = cartItemElem.dataset.invtid
			if (invtId.includes('-124') || invtId.includes('-126')) {
				return true
			}
		}

		return false
	}

	static async checkIfCartHasMattressItemAndDoWhatIsNeeded() {

		const isCheckoutPage = document.location.pathname.includes('checkout')
		const cartHasMattressItem = Cart.hasMattressItem()
		
		if (isCheckoutPage) {

			// Checkout page elements
			const bedShippingNoticeElem = document.getElementById('bedshippingnotice')
			const usChooseAnotherShippingMethodButton = document.getElementById('usNeedSooner')
			const intlChooseAnotherShippingMethodButton = document.getElementById('intlNeedSooner')
			const usShippingOptions = document.getElementById('ulUSDeloptions')
			const intlShippingOptions = document.getElementById('ulIntlDeloptions')
			const usInitialShippingOption = document.getElementById('divUSInitial')
			const intlInitialShippingOption = document.getElementById('divIntlInitial')

			const shippingCountryElem = document.getElementById('addressUI_ddlShipAddrCountry') as HTMLSelectElement
			const shippingCountry = shippingCountryElem.value

			if (cartHasMattressItem) {

				// Show bed shipping notice
				bedShippingNoticeElem.style.display = 'block'
				bedShippingNoticeElem.style.visibility = 'visible'

				await Cart.setShippingMethodAndGetCostsAndUpdateCheckoutUI()

				// Hide 'Choose another shipping method' button
				usChooseAnotherShippingMethodButton.style.display = 'none'
				usChooseAnotherShippingMethodButton.style.visibility = 'hidden'
				intlChooseAnotherShippingMethodButton.style.display = 'none'
				intlChooseAnotherShippingMethodButton.style.visibility = 'hidden'

				// Hide shipping options
				usShippingOptions.style.display = 'none'
				usShippingOptions.style.visibility = 'hidden'
				intlShippingOptions.style.display = 'none'
				intlShippingOptions.style.visibility = 'hidden'

				// Show initial shipping option
				if (shippingCountry === 'US') { 
					usInitialShippingOption.style.display = 'block'
					usInitialShippingOption.style.visibility = 'visible'
				} else {
					intlInitialShippingOption.style.display = 'block'
					intlInitialShippingOption.style.visibility = 'visible'
				}
								
			} else {

				// Hide bed shipping notice
				bedShippingNoticeElem.style.display = 'none'
				bedShippingNoticeElem.style.visibility = 'hidden'

				const result = await Cart.setShippingMethodAndGetCostsAndUpdateCheckoutUI()

				const shippingCosts = result.shippingCosts
				const shippingCostsIds = Object.keys(shippingCosts)

				if (shippingCostsIds.length === 1) {

					// Show initial shipping option
					if (shippingCountry === 'US') { 
						usInitialShippingOption.style.display = 'block'
						usInitialShippingOption.style.visibility = 'visible'
					} else {
						intlInitialShippingOption.style.display = 'block'
						intlInitialShippingOption.style.visibility = 'visible'
					}

					// Show 'Choose another shipping method' button
					if (shippingCountry === 'US') { 
						usChooseAnotherShippingMethodButton.style.display = 'block'
						usChooseAnotherShippingMethodButton.style.visibility = 'visible'
					} else {
						intlChooseAnotherShippingMethodButton.style.display = 'block'
						intlChooseAnotherShippingMethodButton.style.visibility = 'visible'
					}
					
				} else {

					// Hide 'Choose another shipping method' button
					usChooseAnotherShippingMethodButton.style.display = 'none'
					usChooseAnotherShippingMethodButton.style.visibility = 'hidden'
					intlChooseAnotherShippingMethodButton.style.display = 'none'
					intlChooseAnotherShippingMethodButton.style.visibility = 'hidden'

					// Hide initial shipping option
					usInitialShippingOption.style.display = 'none'
					usInitialShippingOption.style.visibility = 'hidden'
					intlInitialShippingOption.style.display = 'none'
					intlInitialShippingOption.style.visibility = 'hidden'

					// Show shipping options
					if (shippingCountry === 'US') {  
						usShippingOptions.style.display = 'block'
						usShippingOptions.style.visibility = 'visible'
					} else {
						intlShippingOptions.style.display = 'block'
						intlShippingOptions.style.visibility = 'visible'
					}
				}
			}
		}
	}

	static saveCartInSalesforce(cartItems: CartItem[]) {

		const SalesforceAbandonedCartUtils: SalesforceAbandonedCartUtils = ((window as any).SalesforceAbandonedCartUtils)

		if (!SalesforceAbandonedCartUtils) {
			console.error('SalesforceAbandonedCartUtils not found.')
			return
		}

		SalesforceAbandonedCartUtils.cartOrOrderData = cartItems.map((cartItem) => ({
			item: cartItem.itemId.trim(),
			quantity: cartItem.quantity,
			price: cartItem.listPrice,
			sale_price: (cartItem.salePrice < cartItem.listPrice)
				? cartItem.salePrice
				: undefined,
			unique_id: cartItem.alternateId
				? cartItem.alternateId
				: cartItem.invtId
					? cartItem.invtId
					: undefined
		}))

		SalesforceAbandonedCartUtils.trackCart()
	}

	static log(message: string, ...optionalParams: any[]) {

		const isDevEnvironment = (window as any).isDevEnvironment

		if (isDevEnvironment) {
			console.log(message, ...optionalParams)
		}
	}

	static checkHTML() {

		const elementsIds = [
			'OCForm1',
			'cart-drawer-empty-cart-paragraph',
			'bubble-cnt',
			'subtotalInUI',
			'carttotalInUI',
			'discountInUI',
			'totalInUI'
		]

		for (const id of elementsIds) {
			if (!document.getElementById(id)) {
				console.error(`Element "#${id}" not found.`)
			}
		}
	}

	static async addYMALItemToCart(itemId: string, itemName: string, itemImage: string, price: number, listPrice: number, triggerElement?: HTMLButtonElement) {
		if (Cart.itemLoading) {
			return
		}

		Cart.log(`[addYMALItemToCart] Adding item to cart...`)
		Cart.log(`[addYMALItemToCart] itemId: ${itemId}`)
		Cart.log(`[addYMALItemToCart] itemName: ${itemName}`)

		const formData = new FormData(document.getElementById('OCForm1') as HTMLFormElement)
		const viewState = encodeURIComponent(API.viewState || formData.get('__VIEWSTATE') as string)
		const viewStateGenerator = encodeURIComponent(formData.get('__VIEWSTATEGENERATOR') as string)
		const viewStateEncrypted = encodeURIComponent(formData.get('__VIEWSTATEENCRYPTED') as string)
		
		if (triggerElement) {
			triggerElement.disabled = true
			triggerElement.textContent = 'ADDING...'
		}

		try {
			const result = await API.addOneItemToCart({
				itemId: itemId,
				quantity: '1',
				extensionsGroups: '',
				extensions: []
			})

			if (!result) {
				throw new Error('Failed to add item to cart')
			}
			const { basketIds, subtotal, subtotalPoints, total, promoCodeDiscount, flatRatePromoDiscount, newCartItems } = result

			Cart.updateCartTotals({
				subtotal: subtotal,
				subtotalPoints: subtotalPoints,
				total: total,
				promoCodeDiscount: promoCodeDiscount,
				flatRatePromoDiscount: flatRatePromoDiscount,
				currency: 'USD'
			})

			// Track add to cart event
			const ga4Item: GA4Item = {
				index: 0,
				item_id: itemId,
				item_name: itemName,
				item_brand: Cart.siteDomainName,
				item_list_id: 'ymal',
				item_list_name: 'You Might Also Like',
				item_category: 'YMAL',
				item_category2: '',
				item_category3: '',
				quantity: 1,
				price: price,
				affiliation: Cart.siteName,
				discount: listPrice - price,
				subscription: 'no'
			}

			GA4Utils.trackAddToCartEvent([ga4Item], {
				id: ga4Item.item_id,
				name: ga4Item.item_name,
				category: ga4Item.item_category,
				value: ga4Item.price,
			})

			Cart.saveCartInSalesforce(newCartItems)

			const cartLabel = (window as any).cartLabel || 'Bag';

			const cartItemsList = document.getElementById('cart-drawer-items')
			const nextId = Cart.getNextAvailableCartItemId();
			const cartItemTemplate = `
				<li 
					id="cart-item-${nextId}"
					class="cart-item"
					data-itemname="${itemName}"
					data-position="${nextId}"
					data-basketid="${basketIds[0]}"
					data-invtid="${itemId}"
					data-itemid="${itemId}"
					data-regularprice="${listPrice}"
					data-price="${price}"
				>
					<img 
						src="${itemImage}" 
						alt="${itemName}" 
						onerror="this.src='images/products/noimage.webp'" 
						style="height: 80px; width: 80px;"
					>
					<div class="cart-item-content">
						<h3>${itemName}<span class="removed-from-cart-text"> was removed from your ${cartLabel}.</span></h3>
						<div class="quantity-wrapper">
							<button 
								class="quantity-decrease"
								type="button" 
								data-operation="decrement" 
								aria-label="Decrement quantity for ${itemName}" 
							></button>
							<input 
								type="number" 
								class="quantity-input"
								pattern="\\d*"
								title="quantity" 
								name="quantity" 
								min="0" 
								max="99" 
								onfocus="this.select();" 
								aria-label="${itemName} quantity" 
								value="1" 
								data-oldvalue="1"
								required
							/>
							<button 
								class="quantity-increase"
								type="button" 
								data-operation="increment" 
								aria-label="Increment quantity for ${itemName}"  
							></button>
						</div>
						<div>
							<p class="price">
								${price.toLocaleString('en-US', { style: 'currency', currency: 'USD' })}
							</p>
						</div>
						<div class="update-item">
							<button 
								id="remove-${nextId}"
								class="icon-close remove-item delete" 
								type="button"
								aria-label="Remove ${itemName} from cart"
							></button>
							<button 
								id="undo-${nextId}"
								class="icon-undo undo" 
								type="button"
								aria-label="Add product ${itemName} back to cart"
							>
								Undo
							</button>
							<div class="loader-dark-small"/>
						</div>
					</div>
				</li>
			`
			cartItemsList.insertAdjacentHTML('beforeend', cartItemTemplate)

			const newItem = document.getElementById(`cart-item-${nextId}`)
			const removeButton = newItem.querySelector('.delete')
			const undoButton = newItem.querySelector('.undo')
			const quantityInput = newItem.querySelector('.quantity-input')
			const quantityDecrease = newItem.querySelector('.quantity-decrease')
			const quantityIncrease = newItem.querySelector('.quantity-increase')

			// Increment the counter for the next item
			Cart.nextCartItemId++

			removeButton.addEventListener('click', (e) => {
				const cartItemElem = (e.target as HTMLElement).closest('li.cart-item') as HTMLUListElement
				const itemPosition = Number.parseInt(cartItemElem.dataset.position)
				const basketId = cartItemElem.dataset.basketid
				const quantityInput = cartItemElem.querySelector('input[name="quantity"]') as HTMLInputElement
				const oldValue = quantityInput.value

				Cart.onClickDeleteProduct({
					basketId: basketId,
					itemPosition: itemPosition,
					oldValue: oldValue
				})
			})

			undoButton.addEventListener('click', (e) => {
				const cartItemElem = (e.target as HTMLElement).closest('li.cart-item') as HTMLUListElement
				const itemPosition = Number.parseInt(cartItemElem.dataset.position)
				const oldBasketId = cartItemElem.dataset.oldbasketid
				const itemId = cartItemElem.dataset.itemid
				const invtId = cartItemElem.dataset.invtid
				const regularPrice = Number.parseFloat(cartItemElem.dataset.regularprice)
				const price = Number.parseFloat(cartItemElem.dataset.price)
				const pricePoints = 0
				const extensionsGroups = ''
				const extensions = ''

				Cart.onClickUndoRemoval({
					oldBasketId: oldBasketId,
					itemPosition: itemPosition,
					itemId: itemId,
					invtId: invtId,
					regularPrice: regularPrice,
					price: price,
					pricePoints: pricePoints,
					extensionsGroups: extensionsGroups,
					extensions: extensions
				})
			})

			quantityInput.addEventListener('focus', (e) => {
				const value = Number.parseInt((e.target as HTMLInputElement).value)
				;(e.target as HTMLInputElement).dataset.oldvalue = value > 99
					? '99'
					: value < 1
						? '1'
						: value.toString()
			})

			quantityInput.addEventListener('focusout', (e) => {
				const quantityInput = e.target as HTMLInputElement
				const floatValue = Number.parseFloat(quantityInput.value)
				const oldValue = Number.parseInt(quantityInput.dataset.oldvalue)

				if (isNaN(floatValue) || !Number.isInteger(floatValue)) {
					clearTimeout(Cart.timeout)
					alert(Cart.QUANTITY_NOT_INTEGER)
					quantityInput.value = oldValue.toString()
				}
			})

			quantityInput.addEventListener('input', (e) => {
				const unorderedListElem = (e.target as HTMLElement).closest('li.cart-item') as HTMLUListElement
				const itemPosition = Number.parseInt(unorderedListElem.dataset.position)

				document.querySelectorAll('.quantity-input').forEach((elem: HTMLInputElement) => {
					if (elem !== e.target) {
						elem.readOnly = true
					}
				})

				document.querySelectorAll('.qtyBtn').forEach((elem: HTMLButtonElement) => {
					elem.disabled = true
				})

				document.querySelectorAll('.delete').forEach((elem: HTMLButtonElement) => {
					elem.disabled = true
				})

				clearTimeout(Cart.timeout)

				Cart.timeout = setTimeout(() => {
					const quantityInput = e.target as HTMLInputElement
					const floatValue = Number.parseFloat(quantityInput.value)
					let newValue = Number.parseInt(quantityInput.value)

					if (isNaN(floatValue) || !Number.isInteger(floatValue)) {
						document.querySelectorAll('.quantity-input').forEach((elem: HTMLInputElement) => {
							if (elem !== e.target) {
								elem.readOnly = false
							}
						})

						document.querySelectorAll('.qtyBtn').forEach((elem: HTMLButtonElement) => {
							elem.disabled = false
						})

						document.querySelectorAll('.delete').forEach((elem: HTMLButtonElement) => {
							elem.disabled = false
						})

						return
					}

					const basketId = unorderedListElem.dataset.basketid
					const price = Number.parseFloat(unorderedListElem.dataset.price)
					const regularPrice = Number.parseFloat(unorderedListElem.dataset.regularprice)
					const pricePoints = 0
					const oldValue = Number.parseInt(quantityInput.dataset.oldvalue)

					if (newValue < 0) {
						newValue = 0
					}

					if (newValue > 99) {
						alert(Cart.QUANTITY_TOO_HIGH)
						newValue = 99
					}

					if (newValue !== oldValue) {
						if (newValue <= 0) {
							Cart.onClickDeleteProduct({
								basketId: basketId,
								itemPosition: itemPosition,
								oldValue: oldValue.toString(),
							})
						}
						else {
							Cart.onUpdateQuantity({
								itemPosition: itemPosition,
								oldValue: oldValue,
								newValue: newValue,
								price: price,
								regularPrice: regularPrice,
								pricePoints: pricePoints,
							})
						}
					} else {
						document.querySelectorAll('.quantity-input').forEach((elem: HTMLInputElement) => {
							if (elem !== e.target) {
								elem.readOnly = false
							}
						})

						document.querySelectorAll('.qtyBtn').forEach((elem: HTMLButtonElement) => {
							elem.disabled = false
						})

						document.querySelectorAll('.delete').forEach((elem: HTMLButtonElement) => {
							elem.disabled = false
						})
					}
				}, Cart.TIME_TO_SAVE_AFTER_INPUT)
			})


			quantityDecrease.addEventListener('click', (e) => {
				const cartElem = (e.target as HTMLElement).closest('li.cart-item') as HTMLUListElement
				const itemPosition = Number.parseInt(cartElem.dataset.position)
				const basketId = cartElem.dataset.basketid
				const price = Number.parseFloat(cartElem.dataset.price)
				const regularPrice = Number.parseFloat(cartElem.dataset.regularprice)
				const pricePoints = 0

				const quantityInput = cartElem.querySelector('input[name="quantity"]') as HTMLInputElement
				const oldValue = Number.parseInt(quantityInput.value)
				let operation = 'decrement'

				let newValue = oldValue - 1

				if (newValue < 0) {
					newValue = 0
				}

				if (newValue !== oldValue) {
					if (newValue <= 0) {
						Cart.onClickDeleteProduct({
							basketId: basketId,
							itemPosition: itemPosition,
							oldValue: oldValue.toString(),
						})
					}
					else {
						Cart.onUpdateQuantity({
							itemPosition: itemPosition,
							oldValue: oldValue,
							newValue: newValue,
							price: price,
							regularPrice: regularPrice,
							pricePoints: pricePoints,
						})
					}
				}
			})

			quantityIncrease.addEventListener('click', (e) => {
				const cartElem = (e.target as HTMLElement).closest('li.cart-item') as HTMLUListElement
				const itemPosition = Number.parseInt(cartElem.dataset.position)
				const basketId = cartElem.dataset.basketid
				const price = Number.parseFloat(cartElem.dataset.price)
				const regularPrice = Number.parseFloat(cartElem.dataset.regularprice)
				const pricePoints = 0

				const quantityInput = cartElem.querySelector('input[name="quantity"]') as HTMLInputElement
				const oldValue = Number.parseInt(quantityInput.value)
				let operation = 'increment'

				let newValue = oldValue + 1

				if (newValue > 99) {
					alert(Cart.QUANTITY_TOO_HIGH)
					newValue = 99
				}

				if (newValue !== oldValue) {
					Cart.onUpdateQuantity({
						itemPosition: itemPosition,
						oldValue: oldValue,
						newValue: newValue,
						price: price,
						regularPrice: regularPrice,
						pricePoints: pricePoints,
					})
				}
			})

			// Update cart count
			const bubbleCountSpanElem = document.getElementById('bubble-cnt') as HTMLSpanElement
			const bubbleCountWrapper = document.querySelector('#cartSumQty') as HTMLSpanElement
			const cartDrawerH2 = document.querySelector('#cart-drawer-head-h2') as HTMLHeadingElement
			const cartDrawerH2Text = cartDrawerH2.innerHTML.split('(')[0].trim()
			const currentCount = Number(bubbleCountSpanElem.innerHTML || '0')
			const newCount = currentCount + 1

			bubbleCountWrapper.style.display = ''
			bubbleCountSpanElem.innerHTML = `${newCount}`
			cartDrawerH2.innerHTML = `${cartDrawerH2Text} (${newCount})`
			Cart.updateCartDrawerItemCount(newCount)

			document.getElementById('cart-drawer-empty-cart-paragraph').style.display = 'none'
			document.getElementById('cart-drawer-checkout-button').style.display = 'flex'

			if (triggerElement) {
				triggerElement.disabled = true
				triggerElement.textContent = 'ADDED!'
				
				const ymalItem = triggerElement.closest('.swiper-slide')
				if (ymalItem) {
					ymalItem.remove()
					
					const swiperElement = document.querySelector('#cart-drawer-ymal-carousel-swiper')
					if (swiperElement) {
						const swiper = (window as any).swiperElements.find((s: any) => s.el === swiperElement)
						if (swiper) {
							swiper.update()
							swiper.updateSlides()
							swiper.updateProgress()
							swiper.updateSlidesClasses()
							
							const remainingYMALItems = document.querySelectorAll('#cart-drawer-ymal-items .swiper-slide')
							if (remainingYMALItems.length === 0) {
								const ymalSection = document.getElementById('cart-drawer-ymal')
								if (ymalSection) {
									ymalSection.style.display = 'none'
								}
							}
						}
					}
				}
			}

		} catch (err) {
			console.error(err)
			if (triggerElement) {
				triggerElement.disabled = false
				triggerElement.textContent = 'ADD TO BAG'
			}
		}
	}

	/**
	 * Updates the item count display in the cart drawer (liItemCountInUI)
	 */
	static updateCartDrawerItemCount(count: number) {
		Cart.updateHeaderCartLabel(count);
		const itemCountElem = document.getElementById('liItemCountInUI');
		if (!itemCountElem) return;
		let text = '';
		if (count === 1) {
			text = '1 item';
		} else if (count > 1) {
			text = `${count} items`;
		}
		itemCountElem.querySelector('span').textContent = text;
	}

	/**
	 * Updates the header bag's screen-reader label (labelAux) so the button name matches the count
	 */
	static updateHeaderCartLabel(count: number) {
		const labelAux = document.getElementById('labelAux');
		if (!labelAux) return;
		labelAux.textContent = count === 0 ? 'Empty' : count === 1 ? 'item' : 'items';
	}
	
	private static getNextAvailableCartItemId(): number {
		const items = document.querySelectorAll('#cart-drawer-items .cart-item');
		const usedIds = new Set<number>();
		items.forEach(item => {
			const id = item.id.replace('cart-item-', '');
			const num = parseInt(id, 10);
			if (!isNaN(num)) usedIds.add(num);
		});
		let nextId = 1;
		while (usedIds.has(nextId)) {
			nextId++;
		}
		return nextId;
	}
}

interface SalesforceAbandonedCartUtils {

	clientEmail: string
	catalogId: string
	subscriberKey: string
	cartOrOrderData: any[]

	/**
	 * Defines if should log messages in the console.
	 */
	debug: boolean

	/**
	 * Should be called as soon as possible.
	 */
	setOrganizationId: (salesforceOrganizationId: string) => void

	/**
	 * Should be called as soon as possible.
	 */
	setCatalogId: (catalogId: string) => void

	/**
	 * Should be called after the client enters his email in:
	 * - The email subscription lightbox
	 * - The email subscription in the footer
	 * - The email subscription in the checkout page
	 */
	setClientEmail: (email: string) => void

	/**
	 * Should be called after `setCatalogId` and `setClientEmail`.
	 */
	setSubscriberKey: () => void

	/**
	 * Should be called for each new product added to the cart (after clicking "Add to cart").
	 */
	addCartOrOrderData: ({ item, quantity, price, salePrice, uniqueId }: {
		item: any
		quantity: any
		price: any
		salePrice?: any
		uniqueId: any
	}) => void

	/**
	 * Sends the cart data to Salesforce.
	 */
	trackCart: () => void

	/**
	 * Should be called if the order is completed by the client.
	 */
	trackConversion: () => void
}